<div *ngIf="isLoading" class="LoadingContainerWrapper Flexbox Flexbox--column Align--center Justify--center" [ngClass]="type">
  <div class="LoadingContainer Flexbox Flexbox--align-center Flexbox--justify-center">
    <mat-spinner [diameter]="diameter"></mat-spinner>
  </div>
</div>